import { render, staticRenderFns } from "./PranesimasPerduoti.vue?vue&type=template&id=377152fb&scoped=true&"
import script from "./PranesimasPerduoti.vue?vue&type=script&lang=js&"
export * from "./PranesimasPerduoti.vue?vue&type=script&lang=js&"
import style0 from "./PranesimasPerduoti.vue?vue&type=style&index=0&id=377152fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377152fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VDataTable,VFooter,VSpacer})
